import Layout from '../../hocs/Layout';
import { FaCircle } from 'react-icons/fa';
import '../../styles/static-pages.css';
import { useEffect } from 'react';


const FAQs =({
})=>{

	useEffect(() => {
      	window.scrollTo(0,0)
    }, [])

	return (
		<Layout>
			<div className='container'>
				<div className='container-policies'>
					<h2>Preguntas Frecuentes</h2>
					<h3>¿Cómo funciona la consulta legal de 30 minutos?</h3>
					<p>La consulta se agenda previamente a través del turnero online y tiene una duración de 30 minutos. En ese 
					tiempo el profesional analiza su situación, responde sus dudas y le brinda una orientación legal clara sobre los 
					pasos a seguir.</p>
					<h3>¿Cuál es el costo de la consulta y cómo se determina?</h3>
					<p>El valor de la consulta se fija de acuerdo a la regulación de honorarios profesionales vigente. El monto 
					corresponde exclusivamente al asesoramiento brindado durante la consulta.</p>
					<h3>¿La consulta es presencial o virtual?</h3>
					<p>Las consultas pueden realizarse de manera presencial o virtual, según disponibilidad y preferencia del 
					cliente, opción que se coordina al momento de reservar el turno.</p>
					<h3>¿Qué documentación debo presentar para una consulta por sucesión?</h3>
					<p>Se recomienda contar con acta de defunción, documentación que acredite el vínculo familiar y, si los 
					hubiera, datos de bienes registrables como inmuebles o vehículos. Si no cuenta con todo, la consulta 
					igualmente puede realizarse.</p>
					<h3>¿Puedo consultar sobre divorcio, alimentos o régimen de comunicación?</h3>
					<p>Sí. Durante la consulta puede evacuar dudas sobre divorcio, cuota alimentaria, cuidado personal, régimen 
					de comunicación y otras cuestiones del derecho de familia.</p>
					<h3>¿La consulta incluye una estimación de honorarios para iniciar un trámite?</h3>
					<p>Sí. En la consulta se brinda una orientación general sobre costos y honorarios del eventual trámite, 
					conforme a la normativa aplicable, sin que ello implique un compromiso de inicio del proceso.</p>
					<h3>¿Atienden contratos inmobiliarios y conflictos relacionados?</h3>
					<p>Sí. El estudio asesora en contratos de alquiler, compraventa, cesiones, rescisiones contractuales y 
					conflictos derivados de relaciones inmobiliarias.</p>
					<h3>¿La consulta me obliga a continuar el caso con el estudio?</h3>
					<p>No. La consulta es independiente y no genera obligación de contratar los servicios del estudio para 
					etapas posteriores.</p>
					<h3>¿Qué sucede si necesito más tiempo que los 30 minutos?</h3>
					<p>En caso de requerir mayor profundidad, se podrá coordinar una nueva consulta o el inicio formal del 
					trámite correspondiente, según el caso.</p>
					<h3>¿Cómo puedo cancelar o reprogramar una consulta?</h3>
					<p>La reprogramación o cancelación se realiza directamente desde el enlace del turnero online, respetando 
					los plazos y condiciones indicados al momento de la reserva.</p>
				</div>
			</div>
		</Layout>
	)
};

export default FAQs;